import { useState, useEffect } from 'react';
import { SystemLayoutStyled } from './styled';
import { Outlet, useNavigate } from 'react-router-dom';
import { userService } from 'apiServices';
import { useSelector, useDispatch } from 'react-redux';
import { setReduxConfigSystem } from 'store/reducers/configSystemReducer';
import { setReduxAuthen } from 'store/reducers/authenReducer';
import { setReduxWallet } from 'store/reducers/walletReducer';
import { ROUTE_PATH } from 'utils/constants/routePath';
import {
  NavbarWidget,
  MenuBarWidget,
  PopupWidget,
  PointExpirePopupWidget,
} from 'widgets';
import { Displays } from 'components';

const SystemLayout = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const { configSystemRedux } = useSelector((state) => state);

  const [_isLoading, _setIsLoading] = useState(true);
  const [_popupDetail, _setPopupDetail] = useState();
  // popup แจ้งเตือนคะแนนใกล้หมดอายุ (แสดงก่อน popup banner)
  const [_pointExpireDetail, _setPointExpireDetail] = useState();
  // เก็บ point + banner ไว้ เพื่อเรียก _renderPopup หลังปิด popup คะแนนหมดอายุ
  const [_pendingBanner, _setPendingBanner] = useState();

  useEffect(() => {
    fetchConfigSystem();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchConfigSystem = async () => {
    let resArr = await Promise.all([
      userService.GET_CONFIG_SYSTEM(),
      userService.GET_MY_PROFILE(),
      userService.GET_MY_WALLET(),
      userService.GET_MY_POPUP_BANNER_LIST(),
      // ถ้า request นี้ล้มเหลวต้องไม่ทำให้แอพเปิดไม่ได้
      userService.GET_MY_POINT_EXPIRE_INFO().catch(() => null),
    ]);
    if (resArr) {
      const point = resArr[2]?.data?.point;
      // กัน banner request ล้มเหลว (apiService ไม่ reject แต่คืน response ที่ไม่มี docs)
      const banners = resArr[3]?.data?.docs || [];
      const pointExpire =
        resArr[4] && resArr[4].status === 200 ? resArr[4].data : null;
      if (pointExpire && pointExpire.show_popup === true) {
        // แสดง popup คะแนนหมดอายุก่อน แล้วค่อยแสดง banner หลังปิด
        _setPointExpireDetail(pointExpire);
        _setPendingBanner({ point, banners });
        // นับว่าโชว์แล้ว (fire-and-forget)
        userService
          .POST_MY_POINT_EXPIRE_POPUP_ACK({
            expiring_point: pointExpire.expiring_point,
          })
          .catch(() => null);
      } else {
        _renderPopup(point, banners);
      }
      dispatch(setReduxConfigSystem(resArr[0].data.docs));
      dispatch(setReduxAuthen(resArr[1].data));
      dispatch(setReduxWallet(resArr[2].data));
      _setIsLoading(false);
    }
  };

  const _handleClosePointExpire = () => {
    _setPointExpireDetail(false);
    if (_pendingBanner) {
      _renderPopup(_pendingBanner.point, _pendingBanner.banners);
      _setPendingBanner(false);
    }
  };

  const _handleRedeemPointExpire = () => {
    _handleClosePointExpire();
    // ไปแท็บแรกของหน้าของรางวัลโดยตรง (path parent เปล่า ๆ จะได้หน้าว่างถ้า TopTab mount อยู่แล้ว)
    navigate(ROUTE_PATH.REWARD_ELECTRONIC);
  };

  const _renderPopup = (point, e) => {
    const isShowAppFist = localStorage.getItem('isShowedAppFirst');
    const isShowOpenedFist = sessionStorage.getItem('isShowedOpenedFirst');
    const displayType1 = isShowAppFist
      ? []
      : e.filter((f) => f.display_type === '1');
    const displayType2 = isShowOpenedFist
      ? []
      : e.filter((f) => f.display_type === '2');
    // process 1 => check has data,  has data show
    if (
      e.length === 0 ||
      (isShowAppFist && isShowOpenedFist) ||
      (displayType1.length === 0 && displayType2.length === 0)
    ) {
      _setPopupDetail(false);
    } else {
      // process 2 => check type by display type prioriry  1, 2
      let tempData = null;
      if (displayType1.length > 0) {
        tempData = displayType1.reduce(
          (result, data) => {
            if (data.type === '1') {
              result.type1.push({ ...data, store: 'localStorage' });
            }
            if (data.type === '2') {
              result.type2.push({ ...data, store: 'localStorage' });
            }
            return result;
          },
          {
            type1: [],
            type2: [],
          }
        );
      } else {
        if (displayType2.length > 0) {
          tempData = displayType2.reduce(
            (result, data) => {
              if (data.type === '1') {
                result.type1.push({ ...data, store: 'sessionStorage' });
              }
              if (data.type === '2') {
                result.type2.push({ ...data, store: 'sessionStorage' });
              }
              return result;
            },
            {
              type1: [],
              type2: [],
            }
          );
        }
      }
      // check condition priority type 2  then  type 1
      if (tempData && tempData.type2.length > 0) {
        let resPassCondition = tempData.type2.find(
          (g) => point >= g.start_point && point <= g.end_point
        );
        if (resPassCondition) {
          _setPopupDetail(resPassCondition);
        } else {
          if (tempData.type1.length > 0) {
            _setPopupDetail(tempData.type1[0]);
          }
        }
      } else {
        if (tempData.type1.length > 0) {
          _setPopupDetail(tempData.type1[0]);
        }
      }
    }
  };

  const _handleClickBg = () => {
    _setPopupDetail(false);
    if (_popupDetail && _popupDetail.store === 'localStorage') {
      localStorage.setItem('isShowedAppFirst', 'true');
    }
    if (_popupDetail && _popupDetail.store === 'sessionStorage') {
      sessionStorage.setItem('isShowedOpenedFirst', 'true');
    }
  };

  const _handleClickPopup = (e) => {
    switch (e.action_type) {
      case '1':
        _handleClickBg();
        break;
      case '2':
        if (e.url) {
          window.open(e.url, '_blank', 'noreferrer');
        }
        _handleClickBg();
        break;
      default:
        break;
    }
  };

  return (
    <SystemLayoutStyled bg={configSystemRedux?.bg_img}>
      <div className="header_mainlayout">
        <NavbarWidget />
      </div>
      <div className="body_mainlayout">
        {_isLoading ? <Displays.Loading /> : <Outlet />}
      </div>
      <div className="menu_mainlayout">
        <MenuBarWidget />
      </div>
      {_pointExpireDetail && (
        <PointExpirePopupWidget
          data={_pointExpireDetail}
          onClose={_handleClosePointExpire}
          onRedeem={_handleRedeemPointExpire}
        />
      )}
      {!_pointExpireDetail && _popupDetail && (
        <PopupWidget
          src={_popupDetail.img_path}
          onClickBg={_handleClickBg}
          onClickPopup={() => _handleClickPopup(_popupDetail)}
        />
      )}
    </SystemLayoutStyled>
  );
};

export default SystemLayout;
